import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
// import Carousel from "./component/Carousel";
import 'animate.css';

const ProgramServices = () => {

    const ref = useRef(null);
    const [inView, setInView] = useState(false);


    return (
        <Layout>


            <section className='pages-container'>
                <h1 className='carousel-text-h1 wow animate__ animate__fadeIn  animated'  data-wow-duration="1.4s">How We <br/>Make Impact</h1>
            </section>

            {/* Services Section */}
            <section className="section-container">
                <div className="services-section">
                    <h4 className="pageh4 mb-3  pagp wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">Our core services are carefully designed to meet the diverse and pressing needs of BIPOC communities across Alberta, Canada and Internationally.</h4>
                </div>
            </section>


            <section className='section'>
                <div className='lineOne  wow animate__animated animate__fadeInLeft' data-wow-duration="1.5s" />
            </section>

            <section className='section-container'>

                <div className='gap-5 align-items-end'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">Elderly & 
                            <br />Vulnerable Adults</h1>
                    </div>
                    <div className='servSecTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Bethel Community Foundation Canada (BCFC) is a registered not-for-profit charity based in Alberta, dedicated to enriching the lives of vulnerable and underserved communities. Our organization is powered by a passionate network of professionals and grassroots changemakers who generously contribute their time, experience, and resources to support individuals in need.</p>
                            <ul className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                                <li>Outreach programs for aging BIPOC seniors</li>
                                <li>Wellness visits and social inclusion activities</li>
                                <li>Advocacy and support for vulnerable adults</li>
                            </ul>
                    </div>

                </div>

                <div className='img-container'>
                    <div className='img-box wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                        <Image src="/images/Elderly1.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                    <div className='img-boxTwo wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/Elderly2.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                </div>

            </section>


            <section className='section-container'>

                <div className='gap-5 align-items-end'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Youth & 
                            <br />Young Adults </h1>
                    </div>
                    <div className='servSecTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Bethel Community Foundation Canada (BCFC) is a registered not-for-profit charity based in Alberta, dedicated to enriching the lives of vulnerable and underserved communities. Our organization is powered by a passionate network of professionals and grassroots changemakers who generously contribute their time, experience, and resources to support individuals in need.</p>
                            <ul className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                                <li>Outreach programs for aging BIPOC seniors</li>
                                <li>Literacy and skills development workshops</li>
                                <li>Violence prevention awareness campaigns</li>
                            </ul>
                    </div>

                </div>

                <div className='img-container'>
                    <div className='img-box wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                        <Image src="/images/Youth1.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                    <div className='img-boxTwo wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/Youth2.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                </div>

            </section>


            <section className='section-container'>

                <div className='gap-5 align-items-end'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Settlement & 
                            <br />Integration Support</h1>
                    </div>
                    <div className='servSecTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Bethel Community Foundation Canada (BCFC) is a registered not-for-profit charity based in Alberta, dedicated to enriching the lives of vulnerable and underserved communities. Our organization is powered by a passionate network of professionals and grassroots changemakers who generously contribute their time, experience, and resources to support individuals in need.</p>
                            <ul className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                                <li>Assistance with job search, applications, and resume reviews</li>
                                <li>Coaching for interviews and transportation logistics</li>
                                <li>Airport pickup and transitional support for newcomers</li>
                            </ul>
                    </div>

                </div>

                <div className='img-container'>
                    <div className='img-box wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                        <Image src="/images/Settlement1.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                    <div className='img-boxTwo wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/Settlement2.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                </div>

            </section>



            <section className='section-container'>

                <div className='gap-5 align-items-end'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Black Men’s Shelter & 
                            <br />Mental Health </h1>
                    </div>
                    <div className='servSecTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">Bethel Community Foundation Canada (BCFC) is a registered not-for-profit charity based in Alberta, dedicated to enriching the lives of vulnerable and underserved communities. Our organization is powered by a passionate network of professionals and grassroots changemakers who generously contribute their time, experience, and resources to support individuals in need.</p>
                            <ul className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                                <li>Support Other Organizations in their provision of Temporary housing and stabilization services</li>
                                <li>Mental health counseling and wellness advocacy</li>
                                <li>Community reintegration and empowerment initiatives</li>
                            </ul>
                    </div>

                </div>

                <div className='img-container'>
                    <div className='img-box wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                        <Image src="/images/metal-health1.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                    <div className='img-boxTwo wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/metal-health2.png"
                            alt="Hero"
                            className="img-fluid box-img"
                        />
                    </div>
                </div>

            </section>




        </Layout>
    );
};

export default ProgramServices;